import { useAppSelector } from 'src/store';
import { IUserInfo } from 'src/store/reducers/user';
import { Address, erc20Abi } from 'viem';
import { UseReadContractParameters, useAccount, useReadContract } from 'wagmi';
import { useAuth } from '../../libs/rainbow';

export interface UseErc20BalanceProps {
  tokenAddress: Address;
  chainId?: number;
}

export const useErc20Balance = (
  { tokenAddress, chainId }: UseErc20BalanceProps,
  { query, ...options }: UseReadContractParameters<typeof erc20Abi, 'balanceOf'> = {},
): any => {
  const { address: userAddress } = useAccount();
  const userInfo: IUserInfo = useAppSelector((state) => state.user);

  const walletAddress = userAddress ?? userInfo.walletAddress;
  const { isAuthenticated } = useAuth();

  return useReadContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: 'balanceOf',
    args: [walletAddress],
    chainId,
    query: {
      enabled: isAuthenticated,
      ...query,
    },
    ...options,
  } as any);
};
